import React from "react";
import InnerBanner from "../component/Innerbanner";
import { Row, Col } from "antd";
import WhyChoose from '../component/Whychooise'
import Post from '../component/Postmention'
import Faqs from '../component/Faqs'
import Service from '../component/Service'
import { CheckCircleOutlined } from "@ant-design/icons";
import Img from "../assets/about-banner.png";
import img1 from '../assets/icon/iconbox.png'


function AboutUs() {
  return (
    <div>
      {/* Top Banner */}
      <InnerBanner name="About Company" title="Home . About us" />

      {/* About Section */}
      <div className="container about-section py-10">
        <Row gutter={[32, 32]} align="middle">
          <Col xs={24} md={12}>
            <div className="main-second-banner">
              <img
                src={Img}
                alt="About Us"
                style={{
                  width: "100%",
                  borderRadius: "16px",
                  objectFit: "cover",
                }}
              />
            </div>
          </Col>

          <Col xs={24} md={12}>
            <h5 className="text-gray-500 mb-2 text-3xl font-custom ">About Us</h5>
            <h2 className="text-4xl font-bold mb-4  font-custom leading-snug">
              Printing Your Imagination, <br />
              <span className="text-primary ">
                Stitch By Stitch
              </span>
            </h2>
          <p className="text-gray-600 mb-6 text-[16px] font-custom">
              At <strong>Initial Global Trade</strong>, we turn your creative
              ideas into high-quality custom apparel that makes a statement.
              Founded in California, we specialize in custom T-shirt printing
              and personalized merchandise for individuals, businesses, and
              organizations who want to stand out.
            </p>

            <Row gutter={[16, 16]} className="mb-6">
              <Col xs={24} sm={12}>
                <div className="p-3 bg-gray-100 rounded-xl flex items-center gap-2">
                  <span role="img" aria-label="box">
                  <img src={img1} alt="" />
                  </span>
                  <strong className="font-custom text-[16px]">Turning Ideas Into Wearable Art</strong>
                </div>
              </Col>
              <Col xs={24} sm={12}>
                <div className="p-3 bg-gray-100 rounded-xl flex items-center gap-2">
                  <span role="img" aria-label="design">
                   <img src={img1} alt="" />
                  </span>
                  <strong className="font-custom">Designed for Everyone</strong>
                </div>
              </Col>
            </Row>

            <ul className="list-none space-y-2 text-gray-700">
              <li className="font-custom ">
                <CheckCircleOutlined className="font-[25px] font-custom text-[#9adad3]-500 mr-2" />
                Transform your vision into high-quality, custom-printed T-shirts.
              </li>
              <li className="font-custom ">
                <CheckCircleOutlined className="text-[#9adad3]-500 mr-2" />
                Choose from premium fabrics and vibrant print options.
              </li>
              <li className="font-custom ">
                <CheckCircleOutlined className="text-[#9adad3]-500 mr-2" />
                From single designs to bulk corporate orders — we’ve got you covered.
              </li>
              <li className="font-custom ">
                <CheckCircleOutlined className="text-[#9adad3]-500  text-[800] mr-2" />
                We combine creativity, craftsmanship, and technology.
              </li>
            </ul>
          </Col>
        </Row>
      </div>
  <WhyChoose />
  <Service />
  <Faqs />
  <Post />
    </div>
  );
}

export default AboutUs;
